import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface FilterProps {
  onSubmit?: () => void;
  nested?: boolean;
  isVisible?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Layout = styled.section<Partial<FilterProps>>`
  position: relative;
  z-index: ${theme.zIndex.filter};
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 0;
  max-height: 0;
  margin-bottom: 0;
  overflow: hidden;
  transition: max-height 375ms linear;

  > div {
    height: 0;
    max-height: 0;
    transition: max-height 375ms linear;
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      height: auto;
      max-height: 1000px;
      margin-bottom: ${toRem(theme.space.lg)};
      overflow: visible;

      > div {
        height: auto;
        max-height: 1000px;
      }
    `}
`;

const Content = styled.div<Partial<FilterProps>>`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: ${toRem(theme.space.xl)} ${toRem(theme.space.xl)};
  border-radius: ${toRem(5.5)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.neutral[100]};

  ${({ nested }) =>
    nested &&
    css`
      padding: 0 ${toRem(theme.space.xl)};
      border-radius: 0;
      border: none;
    `}

  > * {
    margin-bottom: 0;
  }
`;

const Form = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-gap: ${toRem(theme.space.xl)} ${toRem(theme.space.xl)};
  grid-template-columns: repeat(auto-fit, minmax(${toRem(200)}, 1fr));
  width: 100%;

  > * {
    margin-bottom: 0 !important;
  }
`;

const Filter: React.FC<FilterProps> = ({ onSubmit, isVisible, children, className, nested, ...rest }) => (
  <Layout className={className} isVisible={isVisible} data-cy="filter-section" {...rest}>
    <Content nested={nested}>
      <Form onSubmit={onSubmit}>
        <Grid>{children}</Grid>
      </Form>
    </Content>
  </Layout>
);

export default Filter;
